import type { Session, User } from '@supabase/supabase-js'
import { createContext } from 'react'

export interface AuthContextType {
  user: User | null
  session: Session | null
  loading: boolean
  authError: string | null
  signIn: (email: string, password: string) => Promise<void>
  signOut: () => Promise<void>
}

export const AuthContext = createContext<AuthContextType | null>(null)
